import {
  renderParagraph,
  renderHeading,
  renderUnorderedList,
  renderCheckmarkList,
  renderCrossMarkItem,
  renderHorizontalRule
} from './ContentRenderer';

// Detect block type for a single line
const detectLineType = (line) => {
  const trimmed = line.trim();
  if (line.startsWith('# ')) return 'h1';
  if (line.startsWith('## ')) return 'h2';
  if (line.startsWith('### ')) return 'h3';
  if (trimmed === '---') return 'hr';
  if (line.startsWith('- ')) return 'ul';
  if (line.startsWith('✅ ')) return 'check';
  if (line.startsWith('❌ ')) return 'cross';
  return 'p';
};

// Collect consecutive lines that share the same type (for list grouping)
const collectGroup = (lines, startIdx, type) => {
  const items = [lines[startIdx]];
  let i = startIdx;
  while (i + 1 < lines.length && detectLineType(lines[i + 1]) === type) {
    i++;
    items.push(lines[i]);
  }
  return { items, nextIdx: i };
};

// Map each line type to a renderer; returns { node, advanceTo }
const buildBlock = (lines, idx, key) => {
  const line = lines[idx];
  const type = detectLineType(line);

  if (type === 'h1') return { node: renderHeading(line, 1, `h1-${key}`), advanceTo: idx };
  if (type === 'h2') return { node: renderHeading(line, 2, `h2-${key}`), advanceTo: idx };
  if (type === 'h3') return { node: renderHeading(line, 3, `h3-${key}`), advanceTo: idx };
  if (type === 'hr') return { node: renderHorizontalRule(`hr-${key}`), advanceTo: idx };
  if (type === 'cross') return { node: renderCrossMarkItem(line, `cross-${key}`), advanceTo: idx };

  if (type === 'ul') {
    const { items, nextIdx } = collectGroup(lines, idx, 'ul');
    return { node: renderUnorderedList(items, `ul-${key}`), advanceTo: nextIdx };
  }
  if (type === 'check') {
    const { items, nextIdx } = collectGroup(lines, idx, 'check');
    return { node: renderCheckmarkList(items, `check-${key}`), advanceTo: nextIdx };
  }
  return { node: renderParagraph(line, `p-${key}`), advanceTo: idx };
};

// Convert markdown-style content to an array of JSX elements
export const renderMarkdownContent = (content) => {
  const lines = content.trim().split('\n');
  const elements = [];
  let key = 0;
  let i = 0;

  while (i < lines.length) {
    if (!lines[i].trim()) {
      i++;
      continue;
    }
    const { node, advanceTo } = buildBlock(lines, i, key++);
    elements.push(node);
    i = advanceTo + 1;
  }

  return elements;
};
